<div *ngIf="comissioners.length">
  <div [matMenuTriggerFor]="menu" data-cy="Expand more" class="menu-expand">
      <span class="estricta uppercase bolder"> {{getPrefix(accessPoint)}} - {{accessPoint?.identifierCode}} - {{accessPoint?.description}} </span>
      <mat-icon> expand_more </mat-icon>
    </div>
    
    <mat-menu #menu="matMenu" xPosition="before">
      <input mat-menu-item cdkFocusInitial type="text" class="hidden" />
    
      <button *ngFor="let comissioner of comissioners" class="menu-button" mat-menu-item (click)="onClickAcessPoint(comissioner)">
        <span class="menu-icon" *ngIf="!comissioner.parent"></span>
        <span class="menu-description estricta uppercase bolder">
          {{getPrefix(comissioner)}} - {{comissioner?.identifierCode}} - {{ comissioner.description }}
        </span>
      </button>
    </mat-menu>
    
</div>